import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, AppFeatureMetrics, User } from '../../models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class AppsDataService extends HttpBaseService {
    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    updateApp(app: App, formData: FormData): Observable<App> {
        const url = `${this.route}${app.id}`;
        return this.httpPut(url, formData);
    }

    createApp(app: App): Observable<App> {
        const url = `${this.route}`;
        return this.httpPost(url, app);
    }

    loadPlatformApps(): Observable<App[]> {
        const url = `${this.route}`;
        return this.httpGet(url);
    }

    loadUserApps(user: User): Observable<App[]> {
        const url = `${this.route}users/${user.id}`;
        return this.httpGet(url);
    }

    loadApp(appUrl: string): Observable<App> {
        const url = `${this.route}url/${appUrl}`;
        return this.httpGet(url);
    }

    updateAppInformation(app: App): Observable<App> {
        const url = `${this.route}${app.id}/information`;
        return this.httpPatch(url, app);
    }

    setMapLayerPreferenceOnApp(app: App): Observable<App> {
        const url = `${this.route}${app.id}/map-layer-selection`;
        return this.httpPatch(url, app);
    }

    getAppFeatureMetrics(): Observable<AppFeatureMetrics[]> {
        const url = `${this.route}feature-metrics`;
        return this.httpGet(url);
    }
}
